import type { ThemeConfig } from '@chakra-ui/react';

export const config: ThemeConfig = {
  cssVarPrefix: 'm',
};
